export const isGovNumberAllowedToHaveHeavyGoodsConfig = (govNumber) => {
  try {
    const parsed = JSON.parse(process.env.REACT_APP_HEAVY_GOODS_GOV_NUMBER);

    if (Array.isArray(parsed)) {
      return parsed.includes(govNumber);
    }
    return parsed.toString() === govNumber;
  } catch (e) {
    console.error("Failed to parse REACT_APP_HEAVY_GOODS_GOV_NUMBER", e);
    return false;
  }
};
